<template lang='pug'>
div.todayTopic
  SectionTitle(
    :sectionText="title"
    :displayCardCounter="false"
    :displaySeeMoreText="false"
  )
  .article-list
    LatestArticles(v-for='(info, idx) in infos'
      :key='idx'
      :idx='idx + 1'
      :info='info'
      :staticData='staticData'
      :token='token'
    )
</template>

<script>
import LatestArticles from '@/components/latest_articles/latest_article.vue'
import SectionTitle from '@/components/modules/section_title/section_title.vue'
import { getFollowArticleIds } from '@/plugins/api.js'
import { getRouteByParam } from '@/plugins/tool.js'
export default {
  props: {
    title: String,
    type: String,
    categoryId: Number,
    params: Object,
    staticData: Object
  },
  components: {
    LatestArticles,
    SectionTitle
  },
  data() {
    return {
      infos: [],
      typeDict: {},
      token: localStorage.getItem(this.$store.state.storageKeys.token)
    }
  },
  async created() {
    this.typeDict.recommendArticleByContent = this.$store.state.routes.recommendArticleByContent
    await this.getInfo()
  },
  methods: {
    async getInfo() {
      let followIds
      if (this.token)
        followIds = await getFollowArticleIds(this.$store.state, this.$axios)
      let route = this.$store.state.URLs.api + '/' + this.$store.state.lang + this.typeDict[this.type]
      route = getRouteByParam(this.params, route)
      let result = await this.$axios.get(route)
      if (this.type == 'recommendArticleByContent') {
        this.infos = result.data
        this.infos.forEach((info, index, object) => {
          let articleId = this.$route.query.articleId
          if (info.id == articleId)
            object.splice(index, 1);
        })
        this.infos = this.infos.slice(0, 5)
      }
      if (this.token) {
        this.infos.forEach(info => {
          if (followIds && followIds.includes(info.id)){
            info.followStatus = true
          }
          else info.followStatus = false
        })
      }
    }
  }
}
</script>
